import { useState } from "react";

const faqs = [
  {
    q: "Como funciona o processo de abertura de empresa nos EUA?",
    a: "O processo é 100% online e pode ser feito sem precisar viajar. Após você escolher o tipo de empresa (LLC ou C-Corp) e o estado de registro, nossa equipe cuida de toda a documentação. Em média, sua empresa fica pronta em 5 dias úteis.",
  },
  {
    q: "Preciso ter visto ou residência nos EUA para abrir uma empresa?",
    a: "Não! Qualquer pessoa no mundo pode abrir uma empresa nos EUA, independente da nacionalidade ou residência. A ZB Advisor é especializada em atender não-residentes que querem operar no mercado americano.",
  },
  {
    q: "Qual é a diferença entre LLC e C-Corp?",
    a: "A LLC (Limited Liability Company) é mais simples e ideal para pequenas e médias empresas. A C-Corp é mais complexa mas permite emissão de ações, o que é ideal para startups que buscam investimento. Nossa equipe pode te ajudar a escolher o melhor modelo.",
  },
  {
    q: "Quanto custa para abrir uma empresa nos EUA com a ZB Advisor?",
    a: "Nossos planos começam a partir de $199 para abertura de LLC. O valor inclui o registro da empresa, agente registrado por 1 ano e suporte completo em português. Acesse nossa página de preços para ver todos os planos disponíveis.",
  },
  {
    q: "É possível abrir conta bancária nos EUA sendo não-residente?",
    a: "Sim! A ZB Advisor tem parceiros bancários que aceitam não-residentes. Ajudamos você a abrir sua conta bancária americana completamente online, sem precisar viajar aos EUA.",
  },
  {
    q: "A ZB Advisor oferece suporte em português?",
    a: "Sim! Todo o nosso time fala português. Você pode entrar em contato via chat, WhatsApp, email ou telefone e sempre será atendido em português por um especialista que entende sua necessidade.",
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-[#f4f6fb] py-20 px-4 md:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-[#2563eb] text-sm font-semibold tracking-wider uppercase">Dúvidas frequentes</span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#0f2044] mt-2 mb-4">
            Encontre{" "}
            <span className="text-[#2563eb]">respostas rápidas</span>{" "}
            para dúvidas comuns
          </h2>
          <p className="text-gray-500 text-base max-w-lg mx-auto">
            Temos as respostas para as perguntas mais frequentes sobre abertura e gerenciamento de empresas nos EUA.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className={`rounded-2xl border transition-all overflow-hidden ${
                openIdx === idx ? "border-[#2563eb]/40 bg-white" : "border-gray-100 bg-white"
              }`}
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 px-6 py-4 text-left cursor-pointer"
              >
                <span className={`font-semibold text-sm ${openIdx === idx ? "text-[#2563eb]" : "text-[#0f2044]"}`}>
                  {faq.q}
                </span>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-colors ${
                  openIdx === idx ? "bg-[#2563eb] text-white" : "bg-gray-100 text-gray-400"
                }`}>
                  <i className={`${openIdx === idx ? "ri-subtract-line" : "ri-add-line"} text-sm`} />
                </div>
              </button>
              {openIdx === idx && (
                <div className="px-6 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-gray-500 text-sm mb-3">Não encontrou o que procurava?</p>
          <a
            href="#contato"
            className="inline-flex items-center gap-2 bg-[#0f2044] hover:bg-[#162d5c] text-white font-semibold px-6 py-3 rounded-full transition-colors cursor-pointer text-sm whitespace-nowrap"
          >
            <i className="ri-customer-service-2-line" />
            Falar com especialista
          </a>
        </div>
      </div>
    </section>
  );
}
